import { EntityState, StoreConfig, EntityStore } from '@datorama/akita';
import { Injectable, OnDestroy } from '@angular/core';
import { EventInput, DateRangeInput } from '@fullcalendar/core';
import { ProjectActivityService } from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject } from 'rxjs';

export interface CalendarEventsState extends EntityState<EventInput, string> {
    ui: {
        dateRange: DateRangeInput
        typeIds: number[]
        userIds: number[]
    };

}

@Injectable()
@StoreConfig({ name: 'eventsInput' })
@RxJSUnsubscribe
export class CalendarEventsStore extends EntityStore<CalendarEventsState, EventInput, string> implements OnDestroy, RxJSUnsubscribable {
    constructor(
        protected projectActivityService: ProjectActivityService
    ) {
        super({
            ui: {
                dateRange: {
                    start: null,
                    end: null
                },
                typeIds: [],
                userIds: []
            }
        })
    }

    updateDateRange(dateStart: Date, dateEnd: Date) {
        this.update({
            ui: {
                ...this._value().ui,
                dateRange: {
                    start: dateStart,
                    end: dateEnd
                }
            }
        } as CalendarEventsState)
    }

    updateTypeIds(typeIds: number[]) {
        this.update({
            ui: {
                ...this._value().ui,
                typeIds
            }
        } as CalendarEventsState)
    }

    updateUserIds(userIds: number[]) {
        this.update({
            ui: {
                ...this._value().ui,
                userIds
            }
        } as CalendarEventsState)
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

    ngOnDestroy() {

    }
}